import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menuPanel"]

  toggleMenu() {
    this.menuPanelTarget.classList.toggle('hidden');

    // Disallow scrolling when the menu is open
    if (this.menuPanelTarget.classList.contains('hidden')) {
      document.body.style.overflow = 'auto';
    } else {
      document.body.style.overflow = 'hidden';
    }
  }

}